import { useQuery } from "@tanstack/react-query";
import {KNOWLEDGE_BASE_ENDPOINTS} from "../../services/network/endpoints";
import {KnowledgeBaseAPI} from "../../services/network/knowledgeBase-api";

export function useFetchKBFolderFiles(folderId: string | undefined) {
    const {data, error, isLoading} = useQuery({
        queryKey: [KNOWLEDGE_BASE_ENDPOINTS.FETCH_FOLDER_FILES, folderId],
        queryFn: () => {
            if (!folderId) return null;
            return KnowledgeBaseAPI.fetchFolderFiles(folderId);
        },
        enabled: !!folderId
    });

    return {
        KBFilesData: data?.data || [],
        KBFilesError: error,
        KBFilesIsLoading: isLoading,
    };
}
